import { type Brand, resolveBrand } from "src/config/brands";

/**
 * The active white-label brand, resolved from the hostname the app is served
 * from (see `src/config/brands.ts`). The brand can't change during a session,
 * so it's resolved once at module load.
 *
 * Local/dev testing: you can't easily hit a different hostname locally, so a
 * `localStorage.brandHostOverride` (e.g. "app.somedesk.com") takes precedence.
 */
const isTauriRuntime = typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
const host =
  (typeof localStorage !== "undefined" && localStorage.getItem("brandHostOverride")) ||
  (isTauriRuntime ? "app.fraction.com" : window.location.hostname);

export const CURRENT_BRAND: Brand = resolveBrand(host);

export const useBrand = (): Brand => CURRENT_BRAND;

export type { Brand };
